module.exports = __webpack_public_path__ + "img/figma.4949b550.png";